import { Component } from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SuperTabsController} from "../../components/ionic2-super-tabs/src";
import {XpReportService} from "../../services/xp-report.service";
import {InfoModalPage} from "../info-modal/info-modal";

@Component({
  selector: 'page-xp-report-checklist',
  templateUrl: 'xp-report-checklist.html',
})
export class XpReportChecklistPage {

  data: any;
  submitAttempt = false;
  showSurvey = false;
  reportForm: FormGroup;

  enabled = false;
  hasProSubscription = false;
  checklist = [];

  showFooter = false;
  skipChecklist = false;
  country = 'NL';
  unitType = 1;

  checklistInfoContent = 'Alle werkzaamheden worden uitgevoerd volgens de onderstaande normen:<br/>' +
    '<ul>' +
    '<li>NEN1078 Voorziening voor gas met een werkdruk tot en met 500 mbar  - prestatie – eisen * nieuwbouw.</li>' +
    '<li>NEN1087 Ventilatie van gebouwen – Bepalingsmethoden voor nieuwbouw</li>' +
    '<li>NEN2757-1 Bepalingsmethoden voor de geschiktheid van systemen voor de afvoer van rookgas van een gebouw gebonden installaties – Deel 1: Installaties met een belasting kleiner dan of gelijk aan 130 KW op bovenwaarde.</li>' +
    '<li>NEN2768 Meterruimten en bijbehorende bouwkundige voorzieningen in woningen.</li>' +
    '<li>NEN3028 Eisen voor verbrandingsinstallaties</li>' +
    '<li>NEN 8078 voorzieningen voor gas met een werkdruk tot en met 500mbar. Prestatie-eisen -Bestaande bouw</li>' +
    '<li>NEN8087 Ventilatie van gebouw – bepalingsmethode voor bestaande gebouwen. </li>' +
    '<li>NEN8757-1 afvoer van rook van verbrandingstoestellen in gebouwen-bepalingsmethoden voor bestaande bouw.</li>' +
    '<li>NPR3378-0 sectie gasleidingen deel 0 Algemeen</li>' +
    '<li>NPR3378-1 sectie gasleidingen deel 1 Bepalingen van gasdichtheid van de gasinstallatie- Leidraad bij NEN 1078 en NEN 8078</li>' +
    '<li>NPR3378-3 sectie gasleidingen deel 3 Dimensionering gasleiding voor aardgas met de grafiekmethode -Leidraad bij NEN 1078 en NEN 8078</li>' +
    '<li>NPR3378-4 sectie gasleidingen deel 4 Dimensionering gasleiding voor propaan met de grafiekmethode-Leidraad bij NEN 1078 en NEN 8078</li>' +
    '<li>NPR3378-5 sectie gasleidingen deel 5 Aanleg</li>' +
    '<li>NPR3378-8 sectie gasleidingen deel 8 Doorvoeringen van gasleidingen door wanden en vloeren-Leidraad bij NEN 1078 en NEN 8078</li>' +
    '<li>NPR3378-11 sectie gasleidingen deel 11 Aansluitleidingen en aansluitkraan. </li>' +
    '<li>NPR3378-12 sectie gasleidingen deel 12 lasverbindingen in gasleidingen van koolstofstaal voor gebouwgebonden installaties en industriële installaties met een werkdruk van max. 500 mbar-Leidraad bij NEN 1078 en NEN 8087</li>' +
    '<li>NPR3378-13 gasleidingen deel 13 Inbedrijfstelling, bedrijfsvoering, onderhoud en buitenbedrijfstelling van gasleidingen met een werkdruk kleiner of gelijk aan 500 mbar. </li>' +
    '<li>NPR3378-14 sectie gasleidingen deel 14 Gasdruk verhogingsinstallaties- leidraad bij NEN 1078 en NEN 8078 </li>' +
    '<li>NPR3378-20 sectie gastoestellen en opstellingsruimten deel 20 gasgestookte sfeertoestellen met aansluiting op een rookgasafvoersysteem -leidraad bij NEN 1078 en NEN 2757</li>' +
    '<li>NPR3378-21 sectie gastoestellen en opstellingsruimten deel 21 gaskooktoestel in een keuken -leidraad bij NEN 1078</li>' +
    '<li>NPR3378-22 sectie gastoestellen en opstellingsruimten deel 22 opstelplaatsen van gastoestellen, opstellingsruimten en stookruimten-Leidraad bij NEN 1078 en NEN 3028</li>' +
    '<li>NPR3378-40 sectie afvoersystemen deel 40 Het aansluiten van gesloten gastoestellen op CLV systemen werkend op uitsluitend natuurlijke trek (onderdruksystemen) -leidraad bij NEN 2757-1, NEN 2757-2 en NEN 8757</li>' +
    '<li>NPR3378-41 sectie afvoersystemen deel 40 Het aansluiten van gesloten gastoestellen op half CLV systemen werkend op uitsluitend natuurlijke trek (onderdruksystemen) -Leidraad bij NEN 2757-1, NEN 2457-2 en NEN 8757</li>' +
    '<li>NPR3378-45 sectie afvoersystemen deel 45 Vervangen van verbrandingstoestellen, werken aan de rookgasafvoer voorziening verbrandingstoestellen en het beoordelen van de consequenties van wijzigingen aan bestaande de ventilatie en infiltratie van het gebouw-Leidraad bij NEN 2757-1 en NEN 8757</li>' +
    '<li>NPR3378-46 sectie afvoersystemen deel 46 Verbrandingsluchttoevoer en enkelvoudige RGA voor gasgestookte condenserende Type C toestellen. Keuze van constructies en materialen-Leidraad bij NEN 2757-1 en NEN 8757</li>' +
    '<li>NPR3378-47 sectie afvoersystemen deel 47 Enkelvoudige rookgasafvoer voor type B toestellen. Keuze van constructies en materialen en dimensionering met tabellen-Leidraad bij NEN 2757-1</li>' +
    '<li>NPR3378-60 sectie uitmondingen deel 60 Goede werking hinderafstand en verdunningsafstand. Leidraad bij NEN 2757-1 en NEN 2757-2</li>' +
    '<li>NPR3378-80 sectie diversen deel 80 Toestel aanduidingen. Leidraad bij NEN 1078. NEN 2757-1, NEN 2757-2 en NEN -EN1749</li>' +
    '<li>Voorschriften ketelfabrikant</li>' +
    '<li>Voorschriften Rookgasafvoer fabrikanten</li>' +
    '</ul>';

  formConfig1a = [
    {
      category_id: '10100',
      layout_code: 1,
      title: '1. Gasleiding',
      required: true,
      questions: [
        {
          question_id: '1010001',
          code: '',
          question: 'Gasleiding nieuw',
          info_title: 'Gasleiding nieuw',
          info_text: 'Gasleiding nieuw',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
        {
          question_id: '1010002',
          code: '',
          question: 'Gasleiding bestaand / aangepast',
          info_title: 'Gasleiding bestaand / aangepast',
          info_text: 'Gasleiding bestaand / aangepast',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
        {
          question_id: '1020001',
          code: '',
          question: 'Resultaat uitgevoerde druktoets oké',
          info_title: 'Resultaat uitgevoerde druktoets oké',
          info_text: 'Resultaat uitgevoerde druktoets oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020002',
          code: '',
          question: 'Resultaat uitgevoerde lekt test oké',
          info_title: 'Resultaat uitgevoerde lekt test oké',
          info_text: 'Resultaat uitgevoerde lekt test oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020003',
          code: '',
          question: 'Bescherming tegen mechanische beschadiging',
          info_title: 'Bescherming tegen mechanische beschadiging',
          info_text: 'Bescherming tegen mechanische beschadiging',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020004',
          code: '',
          question: 'Voldoende bescherming tegen corrosie',
          info_title: 'Voldoende bescherming tegen corrosie',
          info_text: 'Voldoende bescherming tegen corrosie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020005',
          code: '',
          question: 'Juiste toepassing en materialen',
          info_title: 'Juiste toepassing en materialen',
          info_text: 'Juiste toepassing en materialen',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020006',
          code: '',
          question: 'Stalen gasleiding in kruipruimte',
          info_title: 'Stalen gasleiding in kruipruimte',
          info_text: 'Stalen gasleiding in kruipruimte',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '1020007',
          code: '',
          question: 'Opmerkingen',
          info_title: 'Opmerkingen',
          info_text: 'Opmerkingen',
          answers: [],
          answer: '',
          input_value: true,
          value: ''
        },
      ]
    },
    {
      category_id: '3',
      layout_code: 1,
      title: '2. Opstellingsruimte t.b.v. gastoestellen',
      required: true,
      questions: [
        {
          question_id: '7',
          code: '',
          question: 'Controle juiste montage/opstelling volgens fabrikantvoorschriften',
          info_title: 'Controle juiste montage/opstelling volgens fabrikantvoorschriften',
          info_text: 'Controle juiste montage/opstelling volgens fabrikantvoorschriften',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '8',
          code: '',
          question: 'Luchttoevoer is  gecontroleerd en in orde bevonden',
          info_title: 'Luchttoevoer is  gecontroleerd en in orde bevonden',
          info_text: 'Luchttoevoer is  gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '9',
          code: '',
          question: 'Lucht afvoer is gecontroleerd en in orde bevonden',
          info_title: 'Lucht afvoer is gecontroleerd en in orde bevonden',
          info_text: 'Lucht afvoer is gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '20',
          code: '',
          question: 'Onderhoud ten gevolg van afzuigventilatieapparatuur gecontroleerd',
          info_title: 'Onderhoud ten gevolg van afzuigventilatieapparatuur gecontroleerd',
          info_text: 'Enkel relevant indien de CO-meting in de opstellingsruimte 5-20ppm bedraagt bij open toestellen.',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '10',
          code: '',
          question: 'Onderdruk ten gevolg van afzuigventilatieapparatuur gecontroleerd',
          info_title: 'Onderdruk ten gevolg van afzuigventilatieapparatuur gecontroleerd',
          info_text: 'Enkel relevant indien de CO-meting in de opstellingsruimte 5-20ppm bedraagt bij open toestellen.',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '11',
          code: '',
          question: 'Brandveiligheid gecontroleerd en in orde bevonden',
          info_title: 'Brandveiligheid gecontroleerd en in orde bevonden',
          info_text: 'Brandveiligheid gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '12',
          code: '',
          question: 'Controle van de trek bij toesteltype B11',
          info_title: 'Controle van de trek bij toesteltype B11',
          info_text: 'Controle van de trek bij toesteltype B11',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: '',
        },
        {
          question_id: '13',
          code: '',
          question: 'Opmerkingen',
          info_title: 'Opmerkingen',
          info_text: 'Opmerkingen',
          answers: [],
          answer: '',
          input_value: true,
          value: ''
        },
      ]
    },
    {
      category_id: '4',
      layout_code: 1,
      title: '3. Rookgasafvoer en verbrandingslucht toevoer',
      required: true,
      questions: [
        {
          question_id: '13',
          code: '',
          question: 'Bij vernieuwing gastoestel is de rookgasafvoer vervangen',
          info_title: 'Bij vernieuwing gastoestel is de rookgasafvoer vervangen',
          info_text: 'Bij vernieuwing gastoestel is de rookgasafvoer vervangen',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_questions: ['19']
            },
            {
              value: 'Onbekend',
              hide_questions: ['19']
            }
          ],
          answer: '',
        },
        {
          question_id: '19',
          code: '',
          question: 'Datum rookgasafvoer vervangen',
          info_title: 'Datum rookgasafvoer vervangen',
          info_text: 'Datum rookgasafvoer vervangen',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: 'DD-MM-JJJJ',
          value: ''
        },
        {
          question_id: '18',
          code: '',
          question: 'Is de rookgasafvoer aangesloten op een CLV-systeem?',
          info_title: 'Is de rookgasafvoer aangesloten op een CLV-systeem?',
          info_text: 'Controleer volgens regelgeving.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['13100']
            },
            {
              value: 'N.V.T.',
              hide_categories: ['13100']
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '5',
      layout_code: 1,
      title: '4. Rookgasafvoer leiding gecontroleerd op:',
      required: true,
      questions: [
        {
          question_id: '14',
          code: '',
          question: 'Voldoende beugels en afschot, lekkage',
          info_title: 'Voldoende beugels en afschot, lekkage',
          info_text: 'Voldoende beugels en afschot, lekkage',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            }
          ],
          answer: '',
        },
        {
          question_id: '15',
          code: '',
          question: 'Verbinding niet gelijmd gekit of geschroefd',
          info_title: 'Verbinding niet gelijmd gekit of geschroefd',
          info_text: 'Verbinding niet gelijmd gekit of geschroefd',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            }
          ],
          answer: '',
        },
        {
          question_id: '16',
          code: '',
          question: 'Perforatie niet fabrikant aangebrachte schroefverbindingen of meetnippels',
          info_title: 'Perforatie niet fabrikant aangebrachte schroefverbindingen of meetnippels',
          info_text: 'Perforatie niet fabrikant aangebrachte schroefverbindingen of meetnippels',
          answers: [
            {
              value: 'Oké'
            },
            {
              value: 'Niet oké'
            }
          ],
          answer: '',
        },
        {
          question_id: '17',
          code: '',
          question: 'Uitmonding rookgasafvoer gecontroleerd en in orde bevonden',
          info_title: 'Uitmonding rookgasafvoer gecontroleerd en in orde bevonden',
          info_text: 'Uitmonding rookgasafvoer gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'Niet oké'
            }
          ],
          answer: '',
        },
      ]
    },
  ];

  formConfig1aExtra = [
    {
      category_id: '11100',
      layout_code: 1,
      title: '1e inbedrijfstelling',
      required: true,
      questions: [
        {
          question_id: '1110001',
          code: '',
          question: 'Is het toestel geïnstalleerd volgens de voorschriften van de fabrikant?',
          info_title: 'Is het toestel geïnstalleerd volgens de voorschriften van de fabrikant?',
          info_text: 'Is het toestel geïnstalleerd volgens de voorschriften van de fabrikant?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
        {
          question_id: '1110002',
          code: '',
          question: 'Is er een CO-melder geadviseerd?',
          info_title: 'Is er een CO-melder geadviseerd?',
          info_text: 'Is er een CO-melder geadviseerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },

        {
          question_id: '1110003',
          code: '',
          question: 'Komen de metingen overeen met de door de fabrikant aangegeven waardes?',
          info_title: 'Komen de metingen overeen met de door de fabrikant aangegeven waardes?',
          info_text: 'Komen de metingen overeen met de door de fabrikant aangegeven waardes?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
        {
          question_id: '1110004',
          code: '',
          question: 'Zijn er afwijkingen geconstateerd?',
          info_title: 'Zijn er afwijkingen geconstateerd?',
          info_text: 'Zijn er afwijkingen geconstateerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
        {
          question_id: '1110005',
          code: '',
          question: 'Welke maatregelen worden er genomen voor het herstellen van de afwijkingen?',
          info_title: 'Welke maatregelen worden er genomen voor het herstellen van de afwijkingen?',
          info_text: 'Welke maatregelen worden er genomen voor het herstellen van de afwijkingen?',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: 'Vul in..',
          value: ''
        },
        {
          question_id: '1110005',
          code: '',
          question: 'Is de klant geïnformeerd over het waterzijdig inregelen van de installatie?',
          info_title: 'Is de klant geïnformeerd over het waterzijdig inregelen van de installatie?',
          info_text: 'Bij het plaatsen van een nieuw of bij vervangen van een gasverbrandingstoestel moet het warmteafgiftesysteem waterzijdig worden ingeregeld en gedocumenteerd. Het waterzijdig inregelen is geen eis binnen deze BRL, maar de certificaathouder kan de opdrachtgever wijzen op deze wettelijke verplichting.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: false,
          value: ''
        },
      ]
    },
  ];

  formConfig1b = [
    {
      category_id: '101',
      layout_code: 1,
      title: '1. Algemeen',
      required: true,
      questions: [
        {
          question_id: '101',
          code: 'A-02',
          question: 'Voldoet de opstellingsruimte veiligheidseisen',
          info_title: 'Voldoet de opstellingsruimte veiligheidseisen',
          info_text: 'Raadpleeg hiervoor de documentatie van het toestel en de gasvoorschriften.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '102',
          code: '',
          question: 'Is het toestel op de juiste manier aangesloten?',
          info_title: 'Is het toestel op de juiste manier aangesloten?',
          info_text: '<ul><li>Is de gaszijdige aansluiting oké?</li><li>Is de waterzijdige aansluiting oké en vrij van lekkage?</li><li>Is de cv-zijdige aansluiting oké en vrij van lekkage?</li><li>Is de rookgaszijdige aansluiting oké en vrij van lekkage?</li></ul>',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '104',
          code: 'A-05',
          question: 'Is de waterdruk in het systeem oké',
          info_title: 'Is de waterdruk in het systeem oké',
          info_text: 'Is de waterdruk in het systeem oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '105',
          code: 'M-03',
          question: 'Is de netspanning 230 Volt +/- 15% en aarde oké',
          info_title: 'Is de netspanning 230 Volt +/- 15% en aarde oké',
          info_text: 'Is de netspanning 230 Volt +/- 15% en aarde oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '107',
          code: 'X-02',
          question: 'Zijn er stalen leidingen in de kruipruimte',
          info_title: 'Zijn er stalen leidingen in de kruipruimte',
          info_text: 'Zijn er stalen leidingen in de kruipruimte',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '108',
          code: 'X-06',
          question: 'Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant',
          info_title: 'Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant',
          info_text: 'Toestelonderhoud uitgevoerd volgens opgave ketelfabrikant',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '109',
          code: '',
          question: 'Toesteldocumentatie bij klant aanwezig',
          info_title: 'Toesteldocumentatie bij klant aanwezig',
          info_text: 'Ontbreekt het onderhoudsvoorschrift, dan geldt een onderhoudsfrequentie van 1 jaar. Ontbreekt het gebruiksvoorschrift, dan dient de klant hierover geïnformeerd te worden.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '102',
      layout_code: 1,
      title: '2. Keteldeel',
      required: true,
      questions: [
        {
          question_id: '201',
          code: 'K-01',
          question: 'Warmtewisselaar verbrandingszijdig oké',
          info_title: 'Warmtewisselaar verbrandingszijdig oké',
          info_text: 'Wisselaar en ketel gereinigd en geen sporen van lekkage.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '202',
          code: 'K-02',
          question: 'Verbrandingsruimte oké',
          info_title: 'Verbrandingsruimte oké',
          info_text: 'Afdichting, isolatie in orde bevonden en ruimte gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '203',
          code: 'K-03',
          question: 'Trekonderbreker/verbr. gasverzamelkap oké',
          info_title: 'Trekonderbreker/verbr. gasverzamelkap oké',
          info_text: 'Trekonderbreker/verbr. gasverzamelkap oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '204',
          code: 'K-04',
          question: 'Isolatie oké',
          info_title: 'Isolatie oké',
          info_text: 'Isolatie oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '205',
          code: 'K-05',
          question: 'Kijkglaasje oké',
          info_title: 'Kijkglaasje oké',
          info_text: 'Pakking in goede staat, glas niet gescheurd en gasdicht.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '206',
          code: 'K-06',
          question: 'CV-pomp oké',
          info_title: 'CV-pomp oké',
          info_text: 'Controleren op lekkage en ongewone geluiden.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '207',
          code: 'K-07',
          question: 'Ontluchting oké',
          info_title: 'Ontluchting oké',
          info_text: 'Controleren op lekkage en functionele werking.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '208',
          code: 'K-08',
          question: 'Condens opvang/sifon/afvoer oké',
          info_title: 'Condens opvang/sifon/afvoer oké',
          info_text: 'Controleer op vervuiling en lekkage en met water vullen voor het toestel in bedrijf wordt genomen.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '209',
          code: 'K-09',
          question: 'Ventilator oké',
          info_title: 'Ventilator oké',
          info_text: 'Gereinigd en controle geluid en lagers.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '210',
          code: 'K-10',
          question: 'Luchtinlaatfilter oké',
          info_title: 'Luchtinlaatfilter oké',
          info_text: 'Reinigen of vervangen.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '103',
      layout_code: 1,
      title: '3. Branderdeel',
      required: true,
      questions: [
        {
          question_id: '301',
          code: '',
          question: 'Is het branderdeel oké?',
          info_title: 'Is het branderdeel oké?',
          info_text: '<ul><li>Vlambeeld oké</li><li>Brander oké</li><li>Waakvlam oké</li><li>Spuitstukken oké</li><li>Mengbuizen oké</li><li>Gasblok/aansluiting gasdichtheid oké</li><li>Branderdeel en ruimte gereinigd?</li></ul>',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '104',
      layout_code: 1,
      title: '4. Warm tapwaterdeel',
      required: true,
      questions: [
        {
          question_id: '401',
          code: 'W-01',
          question: 'Inlaatcombinatie oké',
          info_title: 'Inlaatcombinatie oké',
          info_text: 'Controleer op lekkage. Afsluiter op gangbaarheid controleren. Functioneren keerklep controleren.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '402',
          code: 'W-02',
          question: 'Driewegklep Opdrukstift / cartridge oké',
          info_title: 'Driewegklep Opdrukstift / cartridge oké',
          info_text: 'Controleren op lekkage en gangbaarheid.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '404',
          code: 'W-04',
          question: 'Anode oké',
          info_title: 'Anode oké',
          info_text: 'Mate van slijtage beoordelen en vervangen als dit de voorgeschreven grens overschrijd.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '405',
          code: 'W-05',
          question: 'Warmtewisselaar / boiler oké',
          info_title: 'Warmtewisselaar / boiler oké',
          info_text: 'Controleer op lekkage en vraag klant naar klachten.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '406',
          code: 'W-06',
          question: 'Isolatie warmtewisselaar oké',
          info_title: 'Isolatie warmtewisselaar oké',
          info_text: 'Isolatie warmtewisselaar oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '407',
          code: 'M-09',
          question: 'Tapdebiet voldoet aan toestel specificatie',
          info_title: 'Tapdebiet voldoet aan toestel specificatie',
          info_text: 'Tapdebiet voldoet aan toestel specificatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '408',
          code: 'M-10',
          question: 'Is de instelling van de tapwatertemperatuur oké?',
          info_title: 'Is de instelling van de tapwatertemperatuur oké?',
          info_text: 'Is de instelling van de tapwatertemperatuur oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '409',
          code: 'M-20',
          question: 'Stromingsschakelaar oké',
          info_title: 'Stromingsschakelaar oké',
          info_text: 'Stromingsschakelaar oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '105',
      layout_code: 1,
      title: '5. Rookgasafvoer',
      required: true,
      questions: [
        {
          question_id: '501',
          code: 'X-03',
          question: 'Rookgasafvoer / verbrandingslucht toevoer gecontroleerd en akkoord bevonden op: Beugelen / verbindingen / lekkage / recirculatie / en algemene staat oké',
          info_title: 'Rookgasafvoer / verbrandingslucht toevoer gecontroleerd en akkoord bevonden op: Beugelen / verbindingen / lekkage / recirculatie / en algemene staat oké',
          info_text: 'Afdichting, isolatie in orde bevonden en ruimte gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '502',
          code: 'X-01',
          question: 'Is bij ketel vernieuwing de rookgasafvoer vervangen?',
          info_title: 'Is bij ketel vernieuwing de rookgasafvoer vervangen?',
          info_text: 'Is bij ketel vernieuwing de rookgasafvoer vervangen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_questions: ['505']
            },
            {
              value: 'N.V.T.',
              hide_questions: ['505']
            }
          ],
          answer: ''
        },
        {
          question_id: '505',
          code: '',
          question: 'Datum rookgasafvoer vervangen',
          info_title: 'Datum rookgasafvoer vervangen',
          info_text: 'Datum rookgasafvoer vervangen',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: 'DD-MM-JJJJ',
          value: ''
        },
        {
          question_id: '503',
          code: 'X-04',
          question: 'Is de rookgasafvoer aangesloten op een CLV-systeem?',
          info_title: 'Is de rookgasafvoer aangesloten op een CLV-systeem?',
          info_text: 'Controleer volgens regelgeving.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['13100']
            },
            {
              value: 'N.V.T.',
              hide_categories: ['13100']
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '106',
      layout_code: 1,
      title: '6. Regeling en beveiliging',
      required: true,
      questions: [
        {
          question_id: '601',
          code: '',
          question: 'Ontsteking/vlambeveiliging oké',
          info_title: 'Ontsteking/vlambeveiliging oké',
          info_text: '<ul><li>Piezo ontsteking waakvlam oké</li><li>Ionisatie electrode oké</li><li>Ontstekings electrode oké</li><li>Gloeiplug oké</li><li>Thermokoppel oké</li><li>Afvaltijd vlambeveiliging [sec] oké</li></ul>',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '605',
          code: 'R-05',
          question: 'Droogkookbeveiliging / Waterdruksensor oké (R-20)',
          info_title: 'Droogkookbeveiliging / Waterdruksensor oké (R-20)',
          info_text: 'Droogkookbeveiliging / Waterdruksensor oké (R-20)',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '606',
          code: 'R-06',
          question: 'Regelthermostaat oké',
          info_title: 'Regelthermostaat oké',
          info_text: 'Regelthermostaat oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '607',
          code: 'R-07',
          question: 'Maximaalthermostaat oké',
          info_title: 'Maximaalthermostaat oké',
          info_text: 'Maximaalthermostaat oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '608',
          code: 'R-08',
          question: 'Bedrading oké',
          info_title: 'Bedrading oké',
          info_text: 'Bedrading oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '611',
          code: 'R-11',
          question: 'Verbr.gas-/lucht-transportbeveiliging oké',
          info_title: 'Verbr.gas-/lucht-transportbeveiliging oké',
          info_text: '<ul><li>Luchtdruk verschilschakelaar oké</li><li>Verbrandingsgas afvoerbeveiliging (TTB) oké</li></ul>',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '613',
          code: 'A-06',
          question: 'Expansievat oké',
          info_title: 'Expansievat oké',
          info_text: 'Expansievat oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '614',
          code: 'A-07',
          question: 'Overdrukventiel oké',
          info_title: 'Overdrukventiel oké',
          info_text: 'Overdrukventiel oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig1c = [
    {
      category_id: '12100',
      layout_code: 1,
      title: 'Storing',
      required: true,
      questions: [
        {
          question_id: '1210001',
          code: '',
          question: 'Storingscode',
          info_title: '',
          info_text: '',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: 'Code'
        },
        {
          question_id: '1210002',
          code: '',
          question: 'Type klacht',
          info_title: 'Type klacht',
          info_text: 'Type klacht',
          answers: [
            {
              value: 'Geen cv/ww'
            },
            {
              value: 'Warmwater klacht'
            },
            {
              value: 'Cv klacht'
            },
            {
              value: 'Geluidsklacht'
            },
            {
              value: 'Overige...'
            }
          ],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '1210003',
          code: '',
          question: 'Storing opgelost',
          info_title: 'Storing opgelost',
          info_text: 'Storing opgelost',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '1210004',
          code: '',
          question: 'Herhaal bezoek nodig',
          info_title: 'Herhaal bezoek nodig',
          info_text: 'Herhaal bezoek nodig',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '1210005',
          code: '',
          question: 'Opmerkingen',
          info_title: 'Opmerkingen',
          info_text: 'Opmerkingen',
          answers: [],
          answer: '',
          input_value: true,
          value: ''
        },
      ]
    },
  ];

  formConfig1Clv = [
    {
      category_id: '13100',
      layout_code: 1,
      title: 'CLV Systeem',
      required: true,
      questions: [
        {
          question_id: '1310002',
          code: '',
          question: 'Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?',
          info_title: 'Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?',
          info_text: 'Is het werkingsprincipe van het nieuwe en oude toestel overeenkomstig?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1310003',
          code: 'CLV-MJOP',
          question: 'Is er een MJOP aanwezig?',
          info_title: 'Is er een MJOP aanwezig?',
          info_text: 'Is er een MJOP aanwezig? (Meer jaren onderhoud plan)',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1310004',
          code: 'CLV-15Y',
          question: 'Is het CLV systeem ouder dan 15 jaar?',
          info_title: 'Is het CLV systeem ouder dan 15 jaar?',
          info_text: 'Is het CLV systeem ouder dan 15 jaar?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
      ]
    },
  ];

  formConfig1Bbs = [
    {
      category_id: '14100',
      layout_code: 1,
      title: 'Buiten bedrijf stellen',
      required: true,
      questions: [
        {
          question_id: '1410001',
          code: '',
          question: 'Verbrandingstoestel buiten gebruik gesteld?',
          info_title: 'Verbrandingstoestel buiten gebruik gesteld?',
          info_text: 'Verbrandingstoestel buiten gebruik gesteld?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410002',
          code: '',
          question: 'Gastoevoer afgesloten / geblokkeerd?',
          info_title: 'Gastoevoer afgesloten / geblokkeerd?',
          info_text: 'Gastoevoer afgesloten / geblokkeerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410003',
          code: '',
          question: 'Toestel spanningsloos gemaakt?',
          info_title: 'Toestel spanningsloos gemaakt?',
          info_text: 'Toestel spanningsloos gemaakt?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410004',
          code: '',
          question: 'Waarschuwingssticker aangebracht?',
          info_title: 'Waarschuwingssticker aangebracht?',
          info_text: 'Waarschuwingssticker aangebracht?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410005',
          code: '',
          question: 'Bewoner geïnformeerd over het veiligheidsrisico?',
          info_title: 'Bewoner geïnformeerd over het veiligheidsrisico?',
          info_text: 'Bewoner geïnformeerd over het veiligheidsrisico?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410006',
          code: '',
          question: 'Bewoner accepteert voorstel aanpassingen om het veiligheidsrisico weg te nemen?',
          info_title: 'Bewoner accepteert voorstel aanpassingen om het veiligheidsrisico weg te nemen?',
          info_text: 'Bewoner accepteert voorstel aanpassingen om het veiligheidsrisico weg te nemen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        },
        {
          question_id: '1410007',
          code: '',
          question: 'Opdracht voor herstel voorstel ontvangen?',
          info_title: 'Opdracht voor herstel voorstel ontvangen?',
          info_text: 'Opdracht voor herstel voorstel ontvangen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
        }
      ]
    }
  ];

  formConfig1bBelgie = [
    {
      category_id: '15100',
      layout_code: 1,
      title: '1. Reiniging en controle afvoerkanaal',
      required: true,
      questions: [
        {
          question_id: '1510001',
          code: '',
          question: 'Vegen van het afvoerkanaal en het aansluitkanaal',
          info_title: 'Vegen van het afvoerkanaal en het aansluitkanaal',
          info_text: 'Vegen van het afvoerkanaal en het aansluitkanaal',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510002',
          code: '',
          question: 'Druk afvoerkanaal (Pa)',
          info_title: 'Druk afvoerkanaal (Pa)',
          info_text: 'Druk afvoerkanaal (Pa)',
          answers: [],
          input_value: true,
          input_placeholder: '',
          answer: ''
        },
        {
          question_id: '1510003',
          code: '',
          question: 'Controle van de terugslag door middel van een terugslagmelder',
          info_title: 'Controle van de terugslag door middel van een terugslagmelder',
          info_text: 'Controle van de terugslag door middel van een terugslagmelder',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510004',
          code: '',
          question: 'Uitgevoerd door',
          info_title: 'Uitgevoerd door',
          info_text: 'Uitgevoerd door Schoorsteenveger of Erkend technicus?',
          answers: [
            {
              value: 'Schoorsteenveger'
            },
            {
              value: 'Erkend technicus'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '15101',
      layout_code: 1,
      title: '2. Voor alle toestellen',
      required: true,
      questions: [
        {
          question_id: '1510101',
          code: '',
          question: 'Controle rookgaszijdige dichtheid',
          info_title: 'Controle rookgaszijdige dichtheid',
          info_text: 'Controle rookgaszijdige dichtheid',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510102',
          code: '',
          question: 'Controle van de verluchting van het stooklokaal',
          info_title: 'Controle van de verluchting van het stooklokaal',
          info_text: 'Controle van de verluchting van het stooklokaal',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510103',
          code: '',
          question: 'Controle uitmonding afvoerkanaal',
          info_title: 'Controle uitmonding afvoerkanaal',
          info_text: 'Controle uitmonding afvoerkanaal',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510104',
          code: '',
          question: 'Anders, namelijk:',
          info_title: 'Anders, namelijk:',
          info_text: 'Anders, namelijk:',
          answers: [],
          input_value: true,
          answer: ''
        },
      ]
    },
  ];

  formConfig1bBelgie3 = [
    {
      category_id: '15103',
      layout_code: 1,
      title: '3. Voor stooktoestellen gasvormige brandstof',
      required: true,
      questions: [
        {
          question_id: '1510301',
          code: '',
          question: 'Ontstoffen',
          info_title: 'Ontstoffen',
          info_text: 'Ontstoffen',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510302',
          code: '',
          question: 'Reinigen van de branderbedden en de warmtewisselaar',
          info_title: 'Reinigen van de branderbedden en de warmtewisselaar',
          info_text: 'Reinigen van de branderbedden en de warmtewisselaar',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510303',
          code: '',
          question: 'Reinigen van de ventilator en brander',
          info_title: 'Reinigen van de ventilator en brander',
          info_text: 'Reinigen van de ventilator en brander',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig1bBelgie5 = [
    {
      category_id: '15104',
      layout_code: 1,
      title: '5. Voor stooktoestellen vaste brandstof',
      required: true,
      questions: [
        {
          question_id: '1510401',
          code: '',
          question: 'Reinigen van de inwendige delen warmtebron',
          info_title: 'Reinigen van de inwendige delen warmtebron',
          info_text: 'Reinigen van de inwendige delen warmtebron',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510402',
          code: '',
          question: 'Nazicht algemene staat',
          info_title: 'Nazicht algemene staat',
          info_text: 'Nazicht algemene staat',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig1bBelgie4 = [
    {
      category_id: '15105',
      layout_code: 1,
      title: '4. Voor stooktoestellen met ventilatorbrander vloeibare/gasvormige brandstof',
      required: true,
      questions: [
        {
          question_id: '1510501',
          code: '',
          question: 'Reinigen van de rookgasbuizen en turbulatoren',
          info_title: 'Reinigen van de inwendige delen warmtebron',
          info_text: 'Reinigen van de inwendige delen warmtebron',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510502',
          code: '',
          question: 'Reinigen van de ketel',
          info_title: 'Reinigen van de ketel',
          info_text: 'Reinigen van de ketel',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '1510503',
          code: '',
          question: 'Reinigen van de brander',
          info_title: 'Reinigen van de brander',
          info_text: 'Reinigen van de brander',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig2 = [
    {
      category_id: '20100',
      title: '1. Gevel ventilatieroosters',
      required: true,
      questions: [
        {
          question_id: '2010001',
          code: '',
          question: 'Is de visuele check op reinheid gedaan?',
          info_title: 'Is de visuele check op reinheid gedaan?',
          info_text: 'Vervanging roosters als onderdeel defect. Einde levensduur volgens opgave fabrikant. Klachten/zware vervuiling en onderdeel > 80% levensduur',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2010002',
          code: '',
          question: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          info_title: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          info_text: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20200',
      title: '2. Ventielen',
      required: true,
      questions: [
        {
          question_id: '2020001',
          code: '',
          question: 'Is de visuele check op reinheid gedaan?',
          info_title: 'Is de visuele check op reinheid gedaan?',
          info_text: 'Vervanging ventielen als onderdeel defect. Toevoerventielen > 16 jaar, afvoerventielen > 8 jaar',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2020002',
          code: '',
          question: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          info_title: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          info_text: 'Is de bewoner geattendeerd op de mate van onderhoud?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20300',
      title: '3. Luchtkanalen',
      required: true,
      questions: [
        {
          question_id: '2030001',
          code: '',
          question: 'Is de visuele check gedaan met foto’s in combinatie met de plakstripmethode?',
          info_title: 'Is de visuele check gedaan met foto’s in combinatie met de plakstripmethode?',
          info_text: 'Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030002',
          code: '',
          question: 'Zijn er naar aanleiding van de visuele check verdere acties nodig?',
          info_title: 'Zijn er naar aanleiding van de visuele check verdere acties nodig?',
          info_text: 'Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is. Indien visuele check voldoet, geen verdere acties, ga verder naar punt 4.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20301', '20302', '20303', '20304']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20301',
      title: '3.1. De uitkomst van de visuele check van de toevoerkanalen rechtvaardigt reiniging',
      required: true,
      questions: [
        {
          question_id: '2030101',
          code: '',
          question: 'Zijn de te hanteren eisen opgesteld?',
          info_title: 'Zijn de te hanteren eisen opgesteld?',
          info_text: 'Opstellen te hanteren eisen. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030102',
          code: '',
          question: 'Zijn ventielen/gevel ventilatieroosters gereinigd volgens de richtlijn?',
          info_title: 'Zijn ventielen/gevel ventilatieroosters gereinigd volgens de richtlijn?',
          info_text: 'Reinigen ventielen/gevel ventilatieroosters en vervangen/reinigen eventuele filters volgens punt 5.1. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030103',
          code: '',
          question: 'Zijn er filters vervangen/gereinigd volgens de richtlijn?',
          info_title: 'Zijn er filters vervangen/gereinigd volgens de richtlijn?',
          info_text: 'Zijn er filters vervangen/gereinigd volgens de richtlijn?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030104',
          code: '',
          question: 'Zijn ventilator(en) gereinigd volgens de richtlijn?',
          info_title: 'Zijn ventilator(en) gereinigd volgens de richtlijn?',
          info_text: 'Reinigen ventilator(en) volgens punt 4.2. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030105',
          code: '',
          question: 'Is de aanwezige warmtewisselaar gereinigd volgens de richtlijn?',
          info_title: 'Is de aanwezige warmtewisselaar gereinigd volgens de richtlijn?',
          info_text: 'Reinigen aanwezige warmtewisselaar volgens punt 6.2. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030106',
          code: '',
          question: 'Zijn de sensoren volgens de richtlijn gereinigd?',
          info_title: 'Zijn de sensoren volgens de richtlijn gereinigd?',
          info_text: 'Reinigen van sensoren volgens punt 7.2. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030107',
          code: '',
          question: 'Zijn de sensoren volgens de richtlijn gecontroleerd op een goede werking?',
          info_title: 'Zijn de sensoren volgens de richtlijn gecontroleerd op een goede werking?',
          info_text: 'Controle goede werking van sensoren volgens punt 7.2. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030108',
          code: '',
          question: 'Zijn de toe- en afvoerkanalen gereinigd?',
          info_title: 'Zijn de toe- en afvoerkanalen gereinigd?',
          info_text: 'Reinigen van de toe- en afvoerkanalen. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030109',
          code: '',
          question: 'Is de capaciteit gemeten na reiniging?',
          info_title: 'Is de capaciteit gemeten na reiniging?',
          info_text: 'Capaciteit meten na reiniging. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030110',
          code: '',
          question: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_title: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_text: 'Toetsen aan de eisen. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030111',
          code: '',
          question: 'Is de installatie, inclusief ventilator, opnieuw ingeregeld?',
          info_title: 'Is de installatie, inclusief ventilator, opnieuw ingeregeld?',
          info_text: 'Indien nodig opnieuw inregelen van de installatie, inclusief ventilator. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030112',
          code: '',
          question: 'Zijn er naast de reiniging verdere acties vereist?',
          info_title: 'Zijn er naast de reiniging verdere acties vereist?',
          info_text: 'In geval van reiniging geen verdere acties, ga verder naar punt 8. Vervanging kanalen als onderdeel defect en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20302', '20303', '20304', '20400', '20401', '20402', '20403', '20500', '20501', '20502', '20600', '20601', '20602', '20700', '20701', '20702']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20302',
      title: '3.2. De uitkomst van de visuele check van de kanalen rechtvaardigt capaciteitsmeting.',
      required: true,
      questions: [
        {
          question_id: '2030201',
          code: '',
          question: 'Zijn de te hanteren eisen opgesteld?',
          info_title: 'Zijn de te hanteren eisen opgesteld?',
          info_text: 'Zijn de te hanteren eisen opgesteld?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030202',
          code: '',
          question: 'Is de capaciteit gemeten na reiniging ventielen/gevel ventilatieroosters?',
          info_title: 'Is de capaciteit gemeten na reiniging ventielen/gevel ventilatieroosters?',
          info_text: 'Capaciteit meten na reiniging ventielen/gevel ventilatieroosters volgens punt 5.1.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030203',
          code: '',
          question: 'Is de capaciteit gemeten na het vervangen/reinigen eventuele filters?',
          info_title: 'Is de capaciteit gemeten na het vervangen/reinigen eventuele filters?',
          info_text: 'Capaciteit meten na vervangen/reinigen eventuele filters volgens punt 5.1.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030204',
          code: '',
          question: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_title: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_text: 'Voldoet de capaciteit aan de gestelde eisen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030205',
          code: '',
          question: 'Is de installatie opnieuw ingeregeld?',
          info_title: 'Is de installatie opnieuw ingeregeld?',
          info_text: 'Is de installatie opnieuw ingeregeld?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030206',
          code: '',
          question: 'Is de ventilatiecapaciteit voldoende?',
          info_title: 'Is de ventilatiecapaciteit voldoende?',
          info_text: 'Indien ventilatiecapaciteit voldoet, geen verdere acties, ga verder naar punt 4.',
          answers: [
            {
              value: 'Ja',
              hide_categories: ['20303', '20304']
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20303',
      title: '3.3. De capaciteitsmeting wijst uit dat de capaciteit is teruggelopen ten opzichte van de eisen.',
      required: true,
      questions: [
        {
          question_id: '2030301',
          code: '',
          question: 'Is er een visuele inspectie gedaan op luchtlekkages?',
          info_title: 'Is er een visuele inspectie gedaan op luchtlekkages?',
          info_text: 'Visuele inspectie luchtlekkages grote luchtlekkages. Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030302',
          code: '',
          question: 'Heeft de visuele inspectie geleidt tot het repareren/afplakken grote luchtlekkages?',
          info_title: 'Heeft de visuele inspectie geleidt tot het repareren/afplakken grote luchtlekkages?',
          info_text: 'Repareren/afplakken grote luchtlekkages. Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030303',
          code: '',
          question: 'Zijn ventilator(en) gereinigd volgens de richtlijn?',
          info_title: 'Zijn ventilator(en) gereinigd volgens de richtlijn?',
          info_text: 'Reinigen ventilator(en) volgens punt 4.2. Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030304',
          code: '',
          question: 'Is de capaciteit van de ventilator(en) gemeten na reiniging?',
          info_title: 'Is de capaciteit van de ventilator(en) gemeten na reiniging?',
          info_text: 'Capaciteit meten na reiniging ventilator(en). Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030305',
          code: '',
          question: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_title: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_text: 'Voldoet de capaciteit aan de gestelde eisen? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030306',
          code: '',
          question: 'Is de installatie opnieuw ingeregeld?',
          info_title: 'Is de installatie opnieuw ingeregeld?',
          info_text: 'Is de installatie opnieuw ingeregeld? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030307',
          code: '',
          question: 'Is de ventilatiecapaciteit voldoende?',
          info_title: 'Is de ventilatiecapaciteit voldoende?',
          info_text: 'Indien ventilatiecapaciteit voldoet, geen verdere acties, ga verder naar punt 6. Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja',
              hide_categories: ['20304', '20400', '20401', '20402', '20500', '20501', '20502']
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20304',
      title: '3.4. De capaciteitsmeting wijst uit dat de capaciteit nog steeds is teruggelopen ten opzichte van de eisen.',
      required: true,
      questions: [
        {
          question_id: '2030401',
          code: '',
          question: 'Is er een visuele inspectie gedaan op luchtlekkages?',
          info_title: 'Is er een visuele inspectie gedaan op luchtlekkages?',
          info_text: 'Is er een visuele inspectie gedaan op luchtlekkages? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030402',
          code: '',
          question: 'Heeft de visuele inspectie geleidt tot het repareren/afplakken grote luchtlekkages?',
          info_title: 'Heeft de visuele inspectie geleidt tot het repareren/afplakken grote luchtlekkages?',
          info_text: 'Heeft de visuele inspectie geleidt tot het repareren/afplakken grote luchtlekkages? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030403',
          code: '',
          question: 'Zij de kanalen gereinigd?',
          info_title: 'Zij de kanalen gereinigd?',
          info_text: 'Zij de kanalen gereinigd? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030404',
          code: '',
          question: 'Is de capaciteit gemeten na het reinigen van de kanalen?',
          info_title: 'Is de capaciteit gemeten na het reinigen van de kanalen?',
          info_text: 'Is de capaciteit gemeten na het reinigen van de kanalen? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030405',
          code: '',
          question: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_title: 'Voldoet de capaciteit aan de gestelde eisen?',
          info_text: 'Voldoet de capaciteit aan de gestelde eisen? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030406',
          code: '',
          question: 'Is de installatie opnieuw ingeregeld?',
          info_title: 'Is de installatie opnieuw ingeregeld?',
          info_text: 'Is de installatie opnieuw ingeregeld? Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2030407',
          code: '',
          question: 'Zijn er naast de reiniging verdere acties vereist?',
          info_title: 'Zijn er naast de reiniging verdere acties vereist?',
          info_text: 'Na reiniging, geen verdere acties, ga verder naar punt 6. Vervanging kanalen als ernstige luchtlekkages en vervanging redelijkerwijs mogelijk is.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20400', '20401', '20402', '20500', '20501', '20502']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20400',
      title: '4. Ventilatietype A',
      required: true,
      questions: [
        {
          question_id: '2040001',
          code: '',
          question: 'Is het ventilatiesysteem ventilatietype A?',
          info_title: 'Is het ventilatiesysteem ventilatietype A?',
          info_text: 'Indien ventilatietype A, geen verdere acties, ga verder naar punt 9.',
          answers: [
            {
              value: 'Ja',
              hide_categories: ['20401', '20402', '20500', '20501', '20502', '20600', '20601', '20602', '20700', '20701', '20702', '20800', '20801', '20802']
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20401',
      title: '4.1. Ventilatoren',
      required: true,
      questions: [
        {
          question_id: '2040101',
          code: '',
          question: 'Is er een visuele check gedaan aan de hand van foto\'s?',
          info_title: 'Is er een visuele check gedaan aan de hand van foto\'s?',
          info_text: 'Is er een visuele check gedaan aan de hand van foto\'s? Vervanging ventilator als onderdeel defect.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040102',
          code: '',
          question: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is?',
          info_title: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is?',
          info_text: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is? Vervanging ventilator als onderdeel defect. Ventilatoren > 16 jaar.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040103',
          code: '',
          question: 'Zijn er ventilatoren op wisselstroom in de installatie aanwezig?',
          info_title: 'Zijn er ventilatoren op wisselstroom in de installatie aanwezig?',
          info_text: 'Zijn er ventilatoren op wisselstroom in de installatie aanwezig? Vervanging ventilator als onderdeel defect. Ventilatoren > 16 jaar. Gebruik wijkt > 20% af van referentiegebruik.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040104',
          code: '',
          question: 'Is het elektriciteitsgebruik gemeten van de ventilator in laagstand en vergeleken met het referentiegebruik in de productspecificatie?',
          info_title: 'Is het elektriciteitsgebruik gemeten van de ventilator in laagstand en vergeleken met het referentiegebruik in de productspecificatie?',
          info_text: 'Is het elektriciteitsgebruik gemeten van de ventilator in laagstand en vergeleken met het referentiegebruik in de productspecificatie?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040105',
          code: '',
          question: 'Is de afwijking groter dan 20%?',
          info_title: 'Is de afwijking groter dan 20%?',
          info_text: 'Is de afwijking groter dan 20%?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_questions: ['2040106', '2040107']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040106',
          code: '',
          question: 'Is de ventilator vervangen?',
          info_title: 'Is de ventilator vervangen?',
          info_text: 'Is de ventilator vervangen? Vervanging ventilator als onderdeel defect. Ventilator wisselstroom. Ventilatoren > 16 jaar. Gebruik wijkt > 20% af van referentiegebruik.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040107',
          code: '',
          question: 'Zijn er naast de visuele check verdere acties vereist?',
          info_title: 'Zijn er naast de visuele check verdere acties vereist?',
          info_text: 'Zijn er naast de visuele check verdere acties vereist?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20402']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20402',
      title: '4.2 De uitkomst van de visuele check of capaciteitsmeting geeft aan dat de ventilator gereinigd dient te worden.',
      required: true,
      questions: [
        {
          question_id: '2040201',
          code: '',
          question: 'Is het binnenwerk (+ akoestische isolatie) gereinigd?',
          info_title: 'Is het binnenwerk (+ akoestische isolatie) gereinigd?',
          info_text: 'Is het binnenwerk (+ akoestische isolatie) gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040202',
          code: '',
          question: 'Is de motor/waaiercombinatie van de ventilator gereinigd?',
          info_title: 'Is de motor/waaiercombinatie van de ventilator gereinigd?',
          info_text: 'Is de motor/waaiercombinatie van de ventilator gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040203',
          code: '',
          question: 'Is (indien aanwezig) de thermische beveiliging gecontroleerd?',
          info_title: 'Is (indien aanwezig) de thermische beveiliging gecontroleerd?',
          info_text: 'Is (indien aanwezig) de thermische beveiliging gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040204',
          code: '',
          question: 'Zijn (indien nodig) de lagers vervangen?',
          info_title: 'Zijn (indien nodig) de lagers vervangen?',
          info_text: 'Zijn (indien nodig) de lagers vervangen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040205',
          code: '',
          question: 'Zijn de bevestigingen en verbindingen gecontroleerd?',
          info_title: 'Zijn de bevestigingen en verbindingen gecontroleerd?',
          info_text: 'Zijn de bevestigingen en verbindingen gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040206',
          code: '',
          question: 'Is de elektrische bekabeling gecontroleerd op beschadigingen en indien nodig gerepareerd?',
          info_title: 'Is de elektrische bekabeling gecontroleerd op beschadigingen en indien nodig gerepareerd?',
          info_text: 'Is de elektrische bekabeling gecontroleerd op beschadigingen en indien nodig gerepareerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040207',
          code: '',
          question: 'Is de druk- c.q. werkschakelaar gecontroleerd?',
          info_title: 'Is de druk- c.q. werkschakelaar gecontroleerd?',
          info_text: 'Is de druk- c.q. werkschakelaar gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2040208',
          code: '',
          question: 'Is de (indien aanwezig) de druksensor gecontroleerd?',
          info_title: 'Is de (indien aanwezig) de druksensor gecontroleerd?',
          info_text: 'Is de (indien aanwezig) de druksensor gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20500',
      title: '5. Indien geen filters aanwezig zijn, geen verdere acties, ga verder naar punt 6.',
      required: true,
      questions: [
        {
          question_id: '2050001',
          code: '',
          question: 'Zijn er filters aanwezig?',
          info_title: 'Zijn er filters aanwezig?',
          info_text: 'Indien er geen filters aanwezig zijn, geen verdere acties, ga verder naar punt 6.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20501', '20502']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        }
      ]
    },
    {
      category_id: '20501',
      title: '5.1a Filters',
      required: true,
      questions: [
        {
          question_id: '2050101',
          code: '',
          question: 'Is het vervangingsschema geraadpleegd?',
          info_title: 'Is het vervangingsschema geraadpleegd?',
          info_text: 'Is het vervangingsschema geraadpleegd? Vervanging filters als onderdeel defect. Filter > 3-6 maanden, tenzij fabrikant anders instrueert.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20502',
      title: '5.1b De uitkomst van het vervangings-/reinigingsschema geeft aan dat de filters vervangen/gereinigd dienen te worden.',
      required: true,
      questions: [
        {
          question_id: '2050201',
          code: '',
          question: 'Is de bewoner geattendeerd op de wijze en mate van onderhoud?',
          info_title: 'Is de bewoner geattendeerd op de wijze en mate van onderhoud?',
          info_text: 'Is de bewoner geattendeerd op de wijze en mate van onderhoud?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2050202',
          code: '',
          question: 'Zijn de filters gereinigd?',
          info_title: 'Zijn de filters gereinigd?',
          info_text: 'Zijn de filters gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20600',
      title: '6. Warmtewisselaar aanwezig',
      required: true,
      questions: [
        {
          question_id: '2060001',
          code: '',
          question: 'Is er een warmtewisselaar aanwezig?',
          info_title: 'Is er een warmtewisselaar aanwezig?',
          info_text: 'Is er een warmtewisselaar aanwezig?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20601', '20602']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20601',
      title: '6.1 Warmtewisselaar',
      required: true,
      questions: [
        {
          question_id: '2060101',
          code: '',
          question: 'Is er een visuele check gedaan aan de hand van foto\'s?',
          info_title: 'Is er een visuele check gedaan aan de hand van foto\'s?',
          info_text: 'Is er een visuele check gedaan aan de hand van foto\'s? Vervanging WTW als onderdeel defect. Onderdeel > 16 jaar.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2060102',
          code: '',
          question: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is?',
          info_title: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is?',
          info_text: 'Is het onderhoudsschema geraadpleegd/aangevuld als uit visuele check blijkt dat geen onderhoud benodigd is?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2060103',
          code: '',
          question: 'Zijn er naast de visuele check verdere acties vereist?',
          info_title: 'Zijn er naast de visuele check verdere acties vereist?',
          info_text: 'Zijn er naast de visuele check verdere acties vereist?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20602']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20602',
      title: '6.2 De uitkomst van de visuele check geeft aan dat de warmtewisselaar gereinigd dient te worden.',
      required: true,
      questions: [
        {
          question_id: '2060201',
          code: '',
          question: 'Gereinigd volgens onderhoudsschema?',
          info_title: 'Gereinigd volgens onderhoudsschema?',
          info_text: 'Mate van reiniging is afhankelijk van het onderhoudsschema (1x per 2 jaar oppervlakkig/ 1x per 8 jaar grondig).',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2060202',
          code: '',
          question: 'Is de werking van de lamellen van de warmtewisselaar gecontroleerd?',
          info_title: 'Is de werking van de lamellen van de warmtewisselaar gecontroleerd?',
          info_text: 'Is de werking van de lamellen van de warmtewisselaar gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2060203',
          code: '',
          question: 'Is de warmtewisselaar gereinigd na controle op vervuiling?',
          info_title: 'Is de warmtewisselaar gereinigd na controle op vervuiling?',
          info_text: 'Is de warmtewisselaar gereinigd na controle op vervuiling?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2060204',
          code: '',
          question: 'Is de condensaat-afvoer tot en met de sifon onder de WTW gereinigd na controle op vervuiling?',
          info_title: 'Is de condensaat-afvoer tot en met de sifon onder de WTW gereinigd na controle op vervuiling?',
          info_text: 'Is de condensaat-afvoer tot en met de sifon onder de WTW gereinigd na controle op vervuiling?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20700',
      title: '7. Sensoren aanwezig',
      required: true,
      questions: [
        {
          question_id: '2070001',
          code: '',
          question: 'Zijn er sensoren aanwezig?',
          info_title: 'Zijn er sensoren aanwezig?',
          info_text: 'Indien geen sensoren aanwezig zijn, geen verdere acties, ga verder naar punt 8.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20701', '20702']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20701',
      title: '7.1 Sensoren',
      required: true,
      questions: [
        {
          question_id: '2070101',
          code: '',
          question: 'Is het onderhoudsschema geraadpleegd?',
          info_title: 'Is het onderhoudsschema geraadpleegd?',
          info_text: 'Is het onderhoudsschema geraadpleegd? Vervanging als onderdeel defect. Onderdeel > levensduur volgens productspecificaties.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2070102',
          code: '',
          question: 'Is (indien aanwezig) de ventilatiesysteem indicator gecontroleerd?',
          info_title: 'Is (indien aanwezig) de ventilatiesysteem indicator gecontroleerd?',
          info_text: 'Is (indien aanwezig) de ventilatiesysteem indicator gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2070103',
          code: '',
          question: 'Indien volgens onderhoudsschema nog geen onderhoud/controle van de werking benodigd is en geen indicator van het systeem aangeeft dat reiniging nodig is, is er geen verdere acties benodigd. Is er verdere actie benodigd?',
          info_title: 'Verdere actie benodigd?',
          info_text: 'Indien volgens onderhoudsschema nog geen onderhoud/controle van de werking benodigd is en geen indicator van het systeem aangeeft dat reiniging nodig is, is er geen verdere acties benodigd. Ga verder naar punt 8.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20702']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20702',
      title: '7.2 De uitkomst van de indicator of het onderhoudsschema geeft aan dat de sensoren gereinigd/gecontroleerd dienen te worden.',
      required: true,
      questions: [
        {
          question_id: '2070201',
          code: '',
          question: 'Zijn de sensoren gereinigd?',
          info_title: 'Zijn de sensoren gereinigd?',
          info_text: 'Zijn de sensoren gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2070202',
          code: '',
          question: 'Is er een controle gedaan op een goede werking van de sensoren?',
          info_title: 'Is er een controle gedaan op een goede werking van de sensoren?',
          info_text: 'Is er een controle gedaan op een goede werking van de sensoren?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20800',
      title: '8. Indien geen installatieonderdelen op batterijen aanwezig zijn, geen verdere acties, ga verder naar punt 9.',
      required: true,
      questions: [
        {
          question_id: '2080001',
          code: '',
          question: 'Zijn er installatieonderdelen op batterijen aanwezig?',
          info_title: 'Zijn er installatieonderdelen op batterijen aanwezig?',
          info_text: 'Indien geen installatieonderdelen op batterijen aanwezig zijn, geen verdere acties, ga verder naar punt 9.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20801', '20802']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20801',
      title: '8.1a Installatieonderdelen op batterij',
      required: true,
      questions: [
        {
          question_id: '2080101',
          code: '',
          question: 'Is het vervangingsschema geraadpleegd?',
          info_title: 'Is het vervangingsschema geraadpleegd?',
          info_text: 'Is het vervangingsschema geraadpleegd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '2080102',
          code: '',
          question: 'Indien volgens vervangingsschema nog geen batterijen vervangen dienen te worden, is er geen verdere acties vereist. Is er verdere actie vereist?',
          info_title: 'Indien volgens vervangingsschema nog geen batterijen vervangen dienen te worden, is er geen verdere acties vereist. Is er verdere actie vereist?',
          info_text: 'Indien volgens vervangingsschema nog geen batterijen vervangen dienen te worden, geen verdere acties, ga verder naar punt 9.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee',
              hide_categories: ['20802']
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20802',
      title: '8.1b De uitkomst van het vervangingsschema geeft aan dat de batterijen vervangen dienen te worden.',
      required: true,
      questions: [
        {
          question_id: '2080201',
          code: '',
          question: 'Zijn de batterijen vervangen (indien deze onderdeel zijn van het ventilatiesysteem zoals RF-schakelaars?)',
          info_title: 'Zijn de batterijen vervangen (indien deze onderdeel zijn van het ventilatiesysteem zoals RF-schakelaars?)',
          info_text: 'Zijn de batterijen vervangen (indien deze onderdeel zijn van het ventilatiesysteem zoals RF-schakelaars?)',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '20900',
      title: '9. In geval van uitgevoerde werkzaamheden, de bewoner voor akkoord laten tekenen.',
      required: true,
      questions: []
    },
  ];

  formConfig3 = [
    {
      category_id: '30100',
      title: '1. Algemeen',
      required: true,
      questions: [
        {
          question_id: '3010001',
          code: '',
          question: 'Is het waterniveau oké?',
          info_title: 'Is het waterniveau oké?',
          info_text: 'Is het waterniveau oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010002',
          code: '',
          question: 'Is het zoutniveau oké?',
          info_title: 'Is het zoutniveau oké?',
          info_text: 'Is het zoutniveau oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010003',
          code: '',
          question: 'Zijn de waterzijdige aansluitingen oké en lekvrij?',
          info_title: 'Zijn de waterzijdige aansluitingen oké en lekvrij?',
          info_text: 'Zijn de waterzijdige aansluitingen oké en lekvrij?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010010',
          code: '',
          question: 'Zoutvat schoon in orde en niet gescheurd',
          info_title: 'Zoutvat schoon in orde en niet gescheurd',
          info_text: 'Zoutvat schoon in orde en niet gescheurd',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010011',
          code: '',
          question: 'Besturingshuis schoon in orde en niet gescheurd',
          info_title: 'Besturingshuis schoon in orde en niet gescheurd',
          info_text: 'Besturingshuis schoon in orde en niet gescheurd',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010012',
          code: '',
          question: 'Body schoon in orde en niet gescheurd',
          info_title: 'Body schoon in orde en niet gescheurd',
          info_text: 'Body schoon in orde en niet gescheurd',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010013',
          code: '',
          question: 'Resthoud regelaar in orde en lekvrij',
          info_title: 'Resthoud regelaar in orde en lekvrij',
          info_text: 'Resthoud regelaar in orde en lekvrij',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010004',
          code: '',
          question: 'Is de netspanning 230 Volt +/- 15% en aarde oké?',
          info_title: 'Is de netspanning 230 Volt +/- 15% en aarde oké?',
          info_text: 'Is de netspanning 230 Volt +/- 15% en aarde oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010005',
          code: '',
          question: 'Is de afvoer voorzien van een onderbreking?',
          info_title: 'Is de afvoer voorzien van een onderbreking?',
          info_text: 'Is de afvoer voorzien van een onderbreking?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010006',
          code: '',
          question: 'Staat de by-pass in de open stand?',
          info_title: 'Staat de by-pass in de open stand?',
          info_text: 'Staat de by-pass in de open stand?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010007',
          code: '',
          question: 'Heeft u de Batterijen vervangen?',
          info_title: 'Heeft u de Batterijen vervangen?',
          info_text: 'Heeft u de Batterijen vervangen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010008',
          code: '',
          question: 'Toestelonderhoud uitgevoerd volgens opgave fabrikant.',
          info_title: 'Toestelonderhoud uitgevoerd volgens opgave fabrikant.',
          info_text: 'Toestelonderhoud uitgevoerd volgens opgave fabrikant.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3010009',
          code: '',
          question: 'Visuele check reinheid en attenderen bewoners op mate van onderhoud.',
          info_title: 'Visuele check reinheid en attenderen bewoners op mate van onderhoud.',
          info_text: 'Visuele check reinheid en attenderen bewoners op mate van onderhoud.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '30200',
      title: '2. Onderdelen check',
      required: true,
      questions: [
        {
          question_id: '3020001',
          code: '',
          question: 'Is de plunjer oké?',
          info_title: 'Is de plunjer oké?',
          info_text: 'Is de plunjer oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3020002',
          code: '',
          question: 'Is de vlotter oké?',
          info_title: 'Is de vlotter oké?',
          info_text: 'Is de vlotter oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3020003',
          code: '',
          question: 'Is de injector oké?',
          info_title: 'Is de injector oké?',
          info_text: 'Is de injector oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3020004',
          code: '',
          question: 'Is elektromotor oké?',
          info_title: 'Is elektromotor oké?',
          info_text: 'Is elektromotor oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '30300',
      title: '3. Reiniging',
      required: true,
      questions: [
        {
          question_id: '3030001',
          code: '',
          question: 'Is de ontharder aan de binnen en buitenzijde gereinigd?',
          info_title: 'Is de ontharder aan de binnen en buitenzijde gereinigd?',
          info_text: 'Is de ontharder aan de binnen en buitenzijde gereinigd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '30400',
      title: '4. Instellingen',
      required: true,
      questions: [
        {
          question_id: '3040001',
          code: '',
          question: 'Klok op de juiste tijd ingesteld?',
          info_title: 'Klok op de juiste tijd ingesteld?',
          info_text: 'Klok op de juiste tijd ingesteld?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3040002',
          code: '',
          question: 'Regeneratie tijden gecontroleerd / aangepast.',
          info_title: 'Regeneratie tijden gecontroleerd / aangepast.',
          info_text: 'Regeneratie tijden gecontroleerd / aangepast.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '3040003',
          code: '',
          question: 'Zijn de spoelstanden oké en in orde bevonden?',
          info_title: 'Zijn de spoelstanden oké en in orde bevonden?',
          info_text: 'Zijn de spoelstanden oké en in orde bevonden?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig4 = [
    {
      category_id: '40100',
      title: '1. Controlepunten volgens certificaat',
      required: true,
      questions: [
        {
          question_id: '4010001',
          code: '',
          question: 'Is het frame oké?',
          info_title: 'Is het frame oké?',
          info_text: 'Is het frame oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010002',
          code: '',
          question: 'Is de deksel oké?',
          info_title: 'Is de deksel oké?',
          info_text: 'Is de deksel oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010003',
          code: '',
          question: 'Is de opneemarm  vrij van beschadigingen?',
          info_title: 'Is de opneemarm  vrij van beschadigingen?',
          info_text: 'Is de opneemarm  vrij van beschadigingen?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010004',
          code: '',
          question: 'Het testen van de opneemarm op 90° draai is oké',
          info_title: 'Het testen van de opneemarm op 90° draai is oké',
          info_text: 'Het testen van de opneemarm op 90° draai is oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010005',
          code: '',
          question: 'De bouten van de opneemarm zijn oké',
          info_title: 'De bouten van de opneemarm zijn oké',
          info_text: 'De bouten van de opneemarm zijn oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010006',
          code: '',
          question: 'De lasnaden van de opneemarm zijn oké',
          info_title: 'De lasnaden van de opneemarm zijn oké',
          info_text: 'De lasnaden van de opneemarm zijn oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010007',
          code: '',
          question: 'De werking van de pal van de opneemarm is oké',
          info_title: 'De werking van de pal van de opneemarm is oké',
          info_text: 'De werking van de pal van de opneemarm is oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010008',
          code: '',
          question: 'De sluiting van draaiarm op de opneemarm is oké',
          info_title: 'De sluiting van draaiarm op de opneemarm is oké',
          info_text: 'De sluiting van draaiarm op de opneemarm is oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010009',
          code: '',
          question: 'De bouten op de container zijn oké',
          info_title: 'De bouten op de container zijn oké',
          info_text: 'De bouten op de container zijn oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4010010',
          code: '',
          question: 'De constructie van de container is oké',
          info_title: 'De constructie van de container is oké',
          info_text: 'De constructie van de container is oké',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
      ]
    },
    {
      category_id: '40200',
      title: '2. Overige controle (geen invloed op hijscertificaat)',
      required: true,
      questions: [
        {
          question_id: '4020001',
          code: '',
          question: 'Is de deksel oké?',
          info_title: 'Is de deksel oké?',
          info_text: 'Is de deksel oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4020002',
          code: '',
          question: 'Is de afdichtingsrubber van de deksel oké?',
          info_title: 'Is de afdichtingsrubber van de deksel oké?',
          info_text: 'Is de afdichtingsrubber van de deksel oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4020003',
          code: '',
          question: 'Is de radiator van de koeling schoongemaakt?',
          info_title: 'Is de radiator van de koeling schoongemaakt?',
          info_text: 'Is de radiator van de koeling schoongemaakt?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4020004',
          code: '',
          question: 'Zijn de instellingen van de koeling oké?',
          info_title: 'Zijn de instellingen van de koeling oké?',
          info_text: 'Zijn de instellingen van de koeling oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4020005',
          code: '',
          question: 'Blaast er lucht uit de uitblaasmond?',
          info_title: 'Blaast er lucht uit de uitblaasmond?',
          info_text: 'Blaast er lucht uit de uitblaasmond?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '4020006',
          code: '',
          question: 'Is de algehele staat van de koeling oké?',
          info_title: 'Is de algehele staat van de koeling oké?',
          info_text: 'Is de algehele staat van de koeling oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: '',
          input_value: true,
          value: ''
        },
      ]
    },
  ];

  formConfig5 = [
    {
      category_id: '50100',
      title: '1. Installatie controle',
      required: true,
      questions: [
        {
          question_id: '5010001',
          code: '',
          question: 'Reden installatie bezoek',
          info_title: 'Reden installatie bezoek',
          info_text: 'Reden installatie bezoek',
          answers: [
            {
              value: 'Installatie nieuwbouw'
            },
            {
              value: 'Normale bijvulling'
            },
            {
              value: 'Lekkage'
            },
            {
              value: 'Preventieve controle'
            },
            {
              value: 'Periodiek onderhoud'
            },
            {
              value: 'Afbraak installatie'
            },
            {
              value: 'Storing installatie'
            }
          ],
          answer: '',
          display_select: true
        },
        {
          question_id: '5010002',
          code: '',
          question: 'Documenten',
          info_title: 'Documenten',
          info_text: 'Documenten',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010003',
          code: '',
          question: 'Kenplaat installatie',
          info_title: 'Kenplaat installatie',
          info_text: 'Kenplaat installatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010004',
          code: '',
          question: 'Kenplaat van de compressor',
          info_title: 'Kenplaat van de compressor',
          info_text: 'Kenplaat van de compressor',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010005',
          code: '',
          question: 'Kenplaat van de machinekamer',
          info_title: 'Kenplaat van de machinekamer',
          info_text: 'Kenplaat van de machinekamer',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010006',
          code: '',
          question: 'Instructiekaart',
          info_title: 'Instructiekaart',
          info_text: 'Instructiekaart',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010007',
          code: '',
          question: 'Logboek',
          info_title: 'Logboek',
          info_text: 'Logboek',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010008',
          code: '',
          question: 'Stroomschema',
          info_title: 'Stroomschema',
          info_text: 'Stroomschema',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5010009',
          code: '',
          question: 'Conformiteitsverklaring',
          info_title: 'Conformiteitsverklaring',
          info_text: 'Conformiteitsverklaring',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '50200',
      title: '2. Overige controle',
      required: true,
      questions: [
        {
          question_id: '5020001',
          code: '',
          question: 'Volledige controle',
          info_title: 'Volledige controle',
          info_text: 'Volledige controle',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020002',
          code: '',
          question: 'Beperkte controle',
          info_title: 'Beperkte controle',
          info_text: 'Beperkte controle',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020003',
          code: '',
          question: 'Druk beproeving in orde bevonden?',
          info_title: 'Druk beproeving in orde bevonden?',
          info_text: 'Druk beproeving in orde bevonden?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020004',
          code: '',
          question: 'Installatie bijgevuld?',
          info_title: 'Installatie bijgevuld?',
          info_text: 'Installatie bijgevuld?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020005',
          code: '',
          question: 'Installatie gevacuumeerd?',
          info_title: 'Installatie gevacuumeerd?',
          info_text: 'Installatie gevacuumeerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020006',
          code: '',
          question: 'Lekdichtheid controle uitgevoerd?',
          info_title: 'Lekdichtheid controle uitgevoerd?',
          info_text: 'Lekdichtheid controle uitgevoerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020007',
          code: '',
          question: 'Detectie methode',
          info_title: 'Detectie methode',
          info_text: 'Detectie methode',
          answers: [
            {
              value: 'Elektronisch'
            },
            {
              value: 'Spray'
            },
            {
              value: 'Anders, namelijk:'
            }
          ],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '5020008',
          code: '',
          question: 'Lekkage in installatie',
          info_title: 'Lekkage in installatie',
          info_text: 'Lekkage in installatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020009',
          code: '',
          question: 'Aard van lekkage',
          info_title: 'Aard van lekkage',
          info_text: 'Aard van lekkage',
          answers: [],
          answer: '',
          input_value: true,
          value: ''
        },
        {
          question_id: '5020010',
          code: '',
          question: 'Is dit vaker voorgekomen in deze installatie?',
          info_title: 'Is dit vaker voorgekomen in deze installatie?',
          info_text: 'Is dit vaker voorgekomen in deze installatie?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020011',
          code: '',
          question: 'Afzuiging uitgevoerd en oké?',
          info_title: 'Afzuiging uitgevoerd en oké?',
          info_text: 'Afzuiging uitgevoerd en oké?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '5020012',
          code: '',
          question: 'Condenswaterpomp en afvoer gecontroleerd?',
          info_title: 'Condenswaterpomp en afvoer gecontroleerd?',
          info_text: 'Condenswaterpomp en afvoer gecontroleerd?',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig8 = [
    {
      category_id: '80100',
      title: 'Klacht',
      required: true,
      questions: [
        {
          question_id: '8010001',
          code: '',
          question: 'Klacht ontvangen van',
          info_title: 'Klacht ontvangen van',
          info_text: 'Klacht ontvangen van',
          answers: [
            {
              value: 'Eigenaar pand'
            },
            {
              value: 'Huurderpand'
            },
            {
              value: 'Woningbouw vereniging'
            },
            {
              value: 'Kantoor'
            },
            {
              value: 'Via call-centre'
            },
            {
              value: 'Anders...'
            },
          ],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '8010002',
          code: '',
          question: 'Doorgegeven aan monteur via',
          info_title: 'Doorgegeven aan monteur via',
          info_text: 'Doorgegeven aan monteur via',
          answers: [
            {
              value: 'Telefonisch'
            },
            {
              value: 'Via mail'
            },
            {
              value: 'Tijdens andere werkzaamheden in het pand'
            },
            {
              value: 'Anders...'
            }
          ],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '8010003',
          code: '',
          question: 'Klacht',
          info_title: 'Klacht',
          info_text: 'Klacht',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '8010004',
          code: '',
          question: 'Uitgevoerde werkzaamheden',
          info_title: 'Uitgevoerde werkzaamheden',
          info_text: 'Uitgevoerde werkzaamheden',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '8010005',
          code: '',
          question: 'Nog te bestellen materialen',
          info_title: 'Nog te bestellen materialen',
          info_text: 'Nog te bestellen materialen',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
        {
          question_id: '8010006',
          code: '',
          question: 'Klacht verholpen',
          info_title: 'Klacht verholpen',
          info_text: 'Klacht verholpen',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee, herhaal bezoek plannen'
            },
            {
              value: 'Nee, niet meer te repareren'
            },
            {
              value: 'Nee, nieuwe offerte uitbrengen'
            }
          ],
          answer: ''
        },
        {
          question_id: '8010007',
          code: '',
          question: 'Opmerkingen',
          info_title: 'Opmerkingen',
          info_text: 'Opmerkingen',
          answers: [],
          answer: '',
          input_value: true,
          input_placeholder: '',
          value: ''
        },
      ]
    },
  ];

  formConfig9 = [
    {
      category_id: '90100',
      title: '1. Algemeen',
      questions: [
        {
          question_id: '9010001',
          code: '',
          question: 'Controle op toevoer van voldoende verbrandingslucht gecontroleerd en in orde bevonden',
          info_title: 'Controle op toevoer van voldoende verbrandingslucht gecontroleerd en in orde bevonden',
          info_text: 'Controle op toevoer van voldoende verbrandingslucht gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9010002',
          code: '',
          question: 'Alle dichtingen gecontroleerd en in orde bevonden',
          info_title: 'Alle dichtingen gecontroleerd en in orde bevonden',
          info_text: 'Alle dichtingen gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9010003',
          code: '',
          question: 'Toestel gecontroleerd op glasbreuk',
          info_title: 'Toestel gecontroleerd op glasbreuk',
          info_text: 'Toestel gecontroleerd op glasbreuk',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9010004',
          code: '',
          question: 'Decorset gemonteerd volgens instructie fabrikant en niet gewijzigd of iets toegevoegd',
          info_title: 'Decorset gemonteerd volgens instructie fabrikant en niet gewijzigd of iets toegevoegd',
          info_text: 'Decorset gemonteerd volgens instructie fabrikant en niet gewijzigd of iets toegevoegd',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9010005',
          code: '',
          question: 'Bewoner geïnformeerd over het gevaar van CO-vergiftiging',
          info_title: 'Bewoner geïnformeerd over het gevaar van CO-vergiftiging',
          info_text: 'Bewoner geïnformeerd over het gevaar van CO-vergiftiging',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '90200',
      title: '2. Branderdeel',
      questions: [
        {
          question_id: '9020001',
          code: '',
          question: 'Toestel gecontroleerd op vervuiling en in orde bevonden',
          info_title: 'Toestel gecontroleerd op vervuiling en in orde bevonden',
          info_text: 'Toestel gecontroleerd op vervuiling en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9010002',
          code: '',
          question: 'Waakvlam gecontroleerd op mooie blauwe en roetvrij vlambeeld',
          info_title: 'Waakvlam gecontroleerd op mooie blauwe en roetvrij vlambeeld',
          info_text: 'Waakvlam gecontroleerd op mooie blauwe en roetvrij vlambeeld',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '90300',
      title: '3. Rookgasafvoer',
      questions: [
        {
          question_id: '9030001',
          code: '',
          question: 'Toevoerkanaal verbrandingslucht en rookgasafvoerkanaal geïnspecteerd en vrij van blokkades',
          info_title: 'Toevoerkanaal verbrandingslucht en rookgasafvoerkanaal geïnspecteerd en vrij van blokkades',
          info_text: 'Toevoerkanaal verbrandingslucht en rookgasafvoerkanaal geïnspecteerd en vrij van blokkades',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9030002',
          code: '',
          question: 'Aansluiting rookgasafvoer op het toestel gecontroleerd en in orde bevonden',
          info_title: 'Aansluiting rookgasafvoer op het toestel gecontroleerd en in orde bevonden',
          info_text: 'Aansluiting rookgasafvoer op het toestel gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9030003',
          code: '',
          question: 'Muurdoorvoer gecontroleerd op voldoende ruimte en niet geblokkeerd door stuiken e.d.',
          info_title: 'Muurdoorvoer gecontroleerd op voldoende ruimte en niet geblokkeerd door stuiken e.d.',
          info_text: 'Muurdoorvoer gecontroleerd op voldoende ruimte en niet geblokkeerd door stuiken e.d.',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9030004',
          code: '',
          question: 'Eventueel T-stuk gecontroleerd op goede afdichting ook aan onderzijde',
          info_title: 'Eventueel T-stuk gecontroleerd op goede afdichting ook aan onderzijde',
          info_text: 'Eventueel T-stuk gecontroleerd op goede afdichting ook aan onderzijde',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9030005',
          code: '',
          question: 'Afdichting en werking onderdrukluiken gecontroleerd en in orde bevonden',
          info_title: 'Afdichting en werking onderdrukluiken gecontroleerd en in orde bevonden',
          info_text: 'Afdichting en werking onderdrukluiken gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '90400',
      title: '4. Regeling en beveiliging',
      questions: [
        {
          question_id: '9040001',
          code: '',
          question: 'Is het beveiligingssysteem gecontroleerd en in orde bevonden',
          info_title: 'Is het beveiligingssysteem gecontroleerd en in orde bevonden',
          info_text: 'Is het beveiligingssysteem gecontroleerd en in orde bevonden',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9040002',
          code: '',
          question: 'Thermokoppel gecontroleerd op de goede werking',
          info_title: 'Thermokoppel gecontroleerd op de goede werking',
          info_text: 'Thermokoppel gecontroleerd op de goede werking',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig9a = [
    {
      category_id: '90500',
      title: '5. Nieuwe installatie of toestel vervangen ',
      questions: [
        {
          question_id: '9050001',
          code: '',
          question: 'Rookgasafvoerkanaal solide en lekvrij',
          info_title: 'Rookgasafvoerkanaal solide en lekvrij',
          info_text: 'Rookgasafvoerkanaal solide en lekvrij',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9050002',
          code: '',
          question: 'Dak / muurdoorvoer gemonteerd conform eisen fabrikant van het gasverbrandingstoestel en rookgasafvoersysteem',
          info_title: 'Dak / muurdoorvoer gemonteerd conform eisen fabrikant van het gasverbrandingstoestel en rookgasafvoersysteem',
          info_text: 'Dak / muurdoorvoer gemonteerd conform eisen fabrikant van het gasverbrandingstoestel en rookgasafvoersysteem',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9050003',
          code: '',
          question: 'Is het aanwezige rookgasafvoersysteem geschikt en heeft het een levensduur van minimaal 15 jaar na installatiedatum van het toestel',
          info_title: 'Is het aanwezige rookgasafvoersysteem geschikt en heeft het een levensduur van minimaal 15 jaar na installatiedatum van het toestel',
          info_text: 'Is het aanwezige rookgasafvoersysteem geschikt en heeft het een levensduur van minimaal 15 jaar na installatiedatum van het toestel',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9050004',
          code: '',
          question: 'Uitmondingsgebied rookgasafvoerkanaal conform de NEN 1087 en de NEN 2757',
          info_title: 'Uitmondingsgebied rookgasafvoerkanaal conform de NEN 1087 en de NEN 2757',
          info_text: 'Uitmondingsgebied rookgasafvoerkanaal conform de NEN 1087 en de NEN 2757',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9050005',
          code: '',
          question: 'Toestel geïnstalleerd conform installatiehandleiding fabrikant en de NEN 1087 en de NPR 3378-22',
          info_title: 'Toestel geïnstalleerd conform installatiehandleiding fabrikant en de NEN 1087 en de NPR 3378-22',
          info_text: 'Toestel geïnstalleerd conform installatiehandleiding fabrikant en de NEN 1087 en de NPR 3378-22',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '9050006',
          code: '',
          question: 'Gebruikershandleiding aan de klant overhandigd',
          info_title: 'Gebruikershandleiding aan de klant overhandigd',
          info_text: 'Gebruikershandleiding aan de klant overhandigd',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  formConfig10 = [
    {
      category_id: '100100',
      title: '1. Visuele inspectie maaier',
      required: true,
      questions: [
        {
          question_id: '10010001',
          code: '',
          question: 'Is de behuizing zonder scheuren of schade?',
          info_title: 'Is de behuizing zonder scheuren of schade?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10010002',
          code: '',
          question: 'Zijn de bumper en sensoren goed bevestigd?',
          info_title: 'Zijn de bumper en sensoren goed bevestigd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10010003',
          code: '',
          question: 'Is de onderzijde vrij van gras en vuil?',
          info_title: 'Is de onderzijde vrij van gras en vuil?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10010010',
          code: '',
          question: 'Zijn de wielen en rollen vrij en niet versleten?',
          info_title: 'Zijn de wielen en rollen vrij en niet versleten?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10010011',
          code: '',
          question: 'Is het maaidek recht en onbeschadigd?',
          info_title: 'Is het maaidek recht en onbeschadigd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100200',
      title: '2. Messen / Maaidek',
      required: true,
      questions: [
        {
          question_id: '10020001',
          code: '',
          question: 'Zijn de messen scherp en onbeschadigd?',
          info_title: 'Zijn de messen scherp en onbeschadigd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10020002',
          code: '',
          question: 'Zijn de schroeven/mesbevestiging vast?',
          info_title: 'Zijn de schroeven/mesbevestiging vast?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10020003',
          code: '',
          question: 'Is het maaidek gereinigd?',
          info_title: 'Is het maaidek gereinigd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10020004',
          code: '',
          question: 'Werkt de maaihoogte-instelling?',
          info_title: 'Werkt de maaihoogte-instelling?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10020005',
          code: '',
          question: 'Is de balans van de maaischijf in orde?',
          info_title: 'Is de balans van de maaischijf in orde?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100300',
      title: '3. Sensoren & Elektronica',
      required: true,
      questions: [
        {
          question_id: '10030001',
          code: '',
          question: 'Zijn de bots-, til- en optische sensoren schoon?',
          info_title: 'Zijn de bots-, til- en optische sensoren schoon?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10030002',
          code: '',
          question: 'Werkt de obstakeldetectie (bumpertest)?',
          info_title: 'Werkt de obstakeldetectie (bumpertest)?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10030003',
          code: '',
          question: 'Functioneert de helling-/tiltsensor?',
          info_title: 'Functioneert de helling-/tiltsensor?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10030004',
          code: '',
          question: 'Is de GPS/RTK/antenne gereinigd?',
          info_title: 'Is de GPS/RTK/antenne gereinigd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10030005',
          code: '',
          question: 'Is de signaalsterkte gecontroleerd?',
          info_title: 'Is de signaalsterkte gecontroleerd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10030006',
          code: '',
          question: 'Is de firmware up-to-date?',
          info_title: 'Is de firmware up-to-date?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100400',
      title: '4. Accu & Opladen',
      required: true,
      questions: [
        {
          question_id: '10040001',
          code: '',
          question: 'Is de accu zonder corrosie of beschadiging?',
          info_title: 'Is de accu zonder corrosie of beschadiging?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10040002',
          code: '',
          question: 'Zijn de contactpunten schoon?',
          info_title: 'Zijn de contactpunten schoon?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10040003',
          code: '',
          question: 'Is de accutest / status gecontroleerd?',
          info_title: 'Is de accutest / status gecontroleerd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10040004',
          code: '',
          question: 'Is het laadgedrag normaal?',
          info_title: 'Is het laadgedrag normaal?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10040005',
          code: '',
          question: 'Is het laadstation vrij van obstakels?',
          info_title: 'Is het laadstation vrij van obstakels?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10040006',
          code: '',
          question: 'Zijn de laadlippen schoon?',
          info_title: 'Zijn de laadlippen schoon?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100500',
      title: '5. Rij- en Navigatieonderdelen',
      required: true,
      questions: [
        {
          question_id: '10050001',
          code: '',
          question: 'Zijn de wielmotoren zonder afwijkende geluiden?',
          info_title: 'Zijn de wielmotoren zonder afwijkende geluiden?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10050002',
          code: '',
          question: 'Is de test rit naar het laadstation correct?',
          info_title: 'Is de test rit naar het laadstation correct?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10050003',
          code: '',
          question: 'Is het antislipprofiel van de wielen voldoende?',
          info_title: 'Is het antislipprofiel van de wielen voldoende?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10050004',
          code: '',
          question: 'Functioneert het stuursysteem?',
          info_title: 'Functioneert het stuursysteem?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100600',
      title: '6. Software / Logboek',
      required: true,
      questions: [
        {
          question_id: '10060001',
          code: '',
          question: 'Zijn de maairoutes en tijden gecontroleerd?',
          info_title: 'Zijn de maairoutes en tijden gecontroleerd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10060002',
          code: '',
          question: 'Zijn de foutcodes bekeken?',
          info_title: 'Zijn de foutcodes bekeken?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10060003',
          code: '',
          question: 'Is de GPS/RTK herkalibratie uitgevoerd (indien nodig)?',
          info_title: 'Is de GPS/RTK herkalibratie uitgevoerd (indien nodig)?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10060004',
          code: '',
          question: 'Zijn de firmware/instellingen geüpdatet?',
          info_title: 'Zijn de firmware/instellingen geüpdatet?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10060005',
          code: '',
          question: 'Is het logboek bijgewerkt?',
          info_title: 'Is het logboek bijgewerkt?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
    {
      category_id: '100700',
      title: '7. Testcyclus na Onderhoud',
      required: true,
      questions: [
        {
          question_id: '10070001',
          code: '',
          question: 'Is de testmaairoute uitgevoerd?',
          info_title: 'Is de testmaairoute uitgevoerd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10070002',
          code: '',
          question: 'Is het maaibeeld zonder afwijkingen?',
          info_title: 'Is het maaibeeld zonder afwijkingen?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10070003',
          code: '',
          question: 'Is de obstakelstop getest?',
          info_title: 'Is de obstakelstop getest?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10070004',
          code: '',
          question: 'Is het geluidniveau normaal?',
          info_title: 'Is het geluidniveau normaal?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
        {
          question_id: '10070005',
          code: '',
          question: 'Zijn de instellingen geoptimaliseerd?',
          info_title: 'Zijn de instellingen geoptimaliseerd?',
          info_text: 'Aanvullende informatie',
          answers: [
            {
              value: 'Ja'
            },
            {
              value: 'Nee'
            },
            {
              value: 'N.V.T.'
            }
          ],
          answer: ''
        },
      ]
    },
  ];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public formBuilder: FormBuilder,
      public superTabsCtrl: SuperTabsController,
      public modalCtrl: ModalController,
      public reportService: XpReportService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    // Set country
    if (this.data.customers.client && this.data.customers.client.country) {
      this.country = this.data.customers.client.country;
    }
    // Load skipChecklist
    this.skipChecklist = (this.data._skip_checklist === true);
    // Load checklist
    this.checklist = [];
    this.enabled = false;
    if(this.data._selected_units && this.data._selected_units.length > 0){
      let unit = this.data._selected_units[0];
      let unitType = parseInt(unit.unit_model_unit_type);
      this.unitType = unitType;
      let fuelType = unit.fuel_type;
      let unitUnitType = unit.unit_type;
      this.enabled = true;
      // Set hasProSubscription
      this.hasProSubscription = true;
      // Set checklist
      if(this.data.checklist){
        Object.assign(this.checklist, this.data.checklist);
      } else {
        if(unitType === 1){
          // CV
          if((this.data.workorder_type === '1' && this.country != 'BE') || this.data.workorder_type === '5'){
            // Aanmelding nieuw toestel of 1e ingebruikstelling
            Object.assign(this.checklist, this.formConfig1a);
          } else if(this.data.workorder_type === '3'){
            // Storing
            Object.assign(this.checklist, this.formConfig1c);
          } else if(this.data.workorder_type === '7'){
            // Buiten bedrijf stellen
            Object.assign(this.checklist, this.formConfig1Bbs);
          } else {
            // Onderhoud / storing
            if(this.country == 'BE') {
              Object.assign(this.checklist, this.formConfig1bBelgie);
              if(fuelType == 'Stookolie / Mazout') {
                // Vaste brandstof
                this.checklist = this.checklist.concat(this.formConfig1bBelgie4);
              } else if(fuelType == 'Overige' || !fuelType){
                // Overig / onbekend
                this.checklist = this.checklist.concat(this.formConfig1bBelgie3);
                this.checklist = this.checklist.concat(this.formConfig1bBelgie4);
                this.checklist = this.checklist.concat(this.formConfig1bBelgie5);
              } else {
                // Gasvormige brandstof
                this.checklist = this.checklist.concat(this.formConfig1bBelgie3);
                if(unitUnitType == 'Gasketel met ventilator brander'){
                  this.checklist = this.checklist.concat(this.formConfig1bBelgie4);
                }
              }
            } else {
              Object.assign(this.checklist, this.formConfig1b);
            }
          }
          // 1e inbedrijfstelling extra vragen
          if(this.data.workorder_type === '1'){
            this.checklist = this.checklist.concat(this.formConfig1aExtra);
          }
          // CLV systeem extra vragen bij 'Aanmelding nieuw toestel', '1e ingebruikstelling' of 'Onderhoud' (niet in Belgie)
          if((this.data.workorder_type === '1' || this.data.workorder_type === '2' || this.data.workorder_type === '5') && this.country != 'BE'){
            this.checklist = this.checklist.concat(this.formConfig1Clv);
          }
        }
        if(unitType === 2){
          // Ventilatie
          Object.assign(this.checklist, this.formConfig2);
        }
        if(unitType === 3){
          // Waterontharder
          Object.assign(this.checklist, this.formConfig3);
        }
        if(unitType === 4){
          // Hijstoestel
          Object.assign(this.checklist, this.formConfig4);
        }
        if(unitType === 5){
          // Airco
          Object.assign(this.checklist, this.formConfig5);
        }
        if(unitType === 8){
          // Algemeen
          Object.assign(this.checklist, this.formConfig8);
        }
        if(unitType === 9){
          // Gas- of sfeerhaard
          if(this.data.workorder_type === '7'){
            // Buiten bedrijf stellen
            Object.assign(this.checklist, this.formConfig1Bbs);
          } else {
            // Algemene checklist Gas- en sfeerhaarden
            Object.assign(this.checklist, this.formConfig9);
            // 1e inbedrijfstelling extra vragen
            if (this.data.workorder_type === '1') {
              this.checklist = this.checklist.concat(this.formConfig9a);
            }
          }
        }
        if(unitType === 10){
          // Grasmaaier (UY)
          Object.assign(this.checklist, this.formConfig10);
        }
      }
      // Load survey for CV unitType
      this.showSurvey = false;
      if(unitType === 1 && this.hasProSubscription){
        let has_data = (this.data.survey != null);
        this.reportForm = this.formBuilder.group({
          skipped: [(has_data ? this.data.survey.skipped : false)],
          q1: [(has_data ? this.data.survey.q1 : false)],
          q2: [(has_data ? this.data.survey.q2 : false)],
          q3: [(has_data ? this.data.survey.q3 : false)],
          q4: [(has_data ? this.data.survey.q4 : false)],
          q5: [(has_data ? this.data.survey.q5 : false)],
          q6: [(has_data ? this.data.survey.q6 : false)],
          q7: [(has_data ? this.data.survey.q7 : false)],
          q8: [(has_data ? this.data.survey.q8 : false)],
          q9: [(has_data ? this.data.survey.q9 : false)],
          custom_q1: [(has_data ? this.data.survey.custom_q1 : '')],
          custom_q2: [(has_data ? this.data.survey.custom_q2 : '')]
        });
        //this.showSurvey = true; // Survey tijdelijk uitgeschakeld
      }
    }
    // Hide categories and questions
    this.hideCategories();
  }

  ionViewDidEnter() {
    console.log('ReportChecklistPage: ionViewDidEnter');
    this.initForm();
    // XPRNZ: check all questions
    this.setAllCategoriesFirstAnswer();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportChecklistPage: ionViewDidLeave');
    this.save();
  }

  onRadioSelect(e){
    console.log('onRadioSelect: ');
    console.log(e);
  }

  openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

  isValid(){
    if(!this.hasProSubscription){
      return true;
    }
    if(this.skipChecklist){
      return true;
    }
    for(let category of this.checklist){
      if(!category.required){
        continue;
      }
      if(category.hidden){
        continue;
      }
      for(let q of category.questions){
        if(q.answers.length < 1){
          continue;
        }
        if(q.hidden){
          continue;
        }
        if(!q.answer){
          return false;
        }
      }
    }
    return true;
  }

  isCategoryValid(category){
    if(!category.required){
      return false;
    }
    if(category.questions.length == 0){
      return false;
    }
    for(let q of category.questions){
      if(q.hidden){
        continue;
      }
      if(!q.answers || q.answers.length == 0){
        continue;
      }
      if(!q.answer){
        return false;
      }
    }
    return true;
  }

  isCategoryInvalid(category){
    if(!category.required){
      return false;
    }
    if(category.questions.length == 0){
      return false;
    }
    for(let q of category.questions){
      if(q.hidden){
        continue;
      }
      if(!q.answers || q.answers.length == 0){
        continue;
      }
      if(!q.answer){
        return true;
      }
    }
    return false;
  }

  setCategoryFirstAnswer(category){
    for(let q of category.questions){
      if(!q.answer && q.answers && q.answers.length > 0){
        q.answer = q.answers[0].value;
      }
    }
    this.hideCategories();
  }

  setAllCategoriesFirstAnswer(){
    for(let c of this.checklist){
      this.setCategoryFirstAnswer(c);
    }
  }

  setCategoryAnswer(category, index){
    if(!index) index = 0;
    for(let q of category.questions){
      if(q.answers && q.answers.length > index){
        q.answer = q.answers[index].value;
      }
    }
    this.hideCategories();
  }

  onQuestionChange(question){
    let hide_categories = false;
    for(let answer of question.answers){
      if(answer.hide_categories){
        hide_categories = true;
        break;
      }
      if(answer.hide_questions){
        hide_categories = true;
        break;
      }
    }
    if(hide_categories){
      this.hideCategories();
    }
  }

  hideCategories(){
    for(let category of this.checklist){
      category.hidden = false;
      for(let q of category.questions){
        q.hidden = false;
      }
    }
    for(let category of this.checklist){
      for(let q of category.questions){
        for(let a of q.answers){
          // Hide categories
          if(a.hide_categories && q.answer == a.value){
            for(let category_id of a.hide_categories){
              this.hideCategory(category_id);
            }
          }
          // Hide answers
          if(a.hide_questions && q.answer == a.value){
            for(let question_id of a.hide_questions){
              this.hideQuestion(question_id);
            }
          }
        }
      }
    }
  }

  hideCategory(category_id){
    for(let category of this.checklist){
      if(category.category_id == category_id){
        category.hidden = true;
        if(category.questions){
          for(let q of category.questions){
            q.answer = '';
          }
        }
      }
    }
  }

  hideQuestion(question_id){
    for(let category of this.checklist){
      if(category.questions){
        for(let q of category.questions){
          if(q.question_id == question_id) {
            q.hidden = true;
            q.answer = '';
          }
        }
      }
    }
  }

  surveyCheckAll(){
    if(!this.showSurvey){
      return;
    }
    this.reportForm.get('q1').setValue(true);
    this.reportForm.get('q2').setValue(true);
    this.reportForm.get('q3').setValue(true);
    this.reportForm.get('q4').setValue(true);
    this.reportForm.get('q5').setValue(true);
    this.reportForm.get('q6').setValue(true);
    this.reportForm.get('q7').setValue(true);
    this.reportForm.get('q8').setValue(true);
    this.reportForm.get('q9').setValue(true);
  }

  save(){
    if(this.skipChecklist || this.isValid()){
      this.superTabsCtrl.setColor('reportChecklistPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportChecklistPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportChecklistPage', 'tab_error', 'mainTabs');
      this.data._valid.reportChecklistPage = -1;
    }
    this.data.checklist = this.checklist;
    this.data._skip_checklist = this.skipChecklist;
    if(this.skipChecklist){
      this.checklist = [];
      this.data.checklist = null;
      console.log('Clear checklist');
      console.log(this.data);
      console.log(this.checklist);
    }
    if(this.showSurvey){
      this.data.survey = this.reportForm.value;
    }
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportRepairsPage', 'mainTabs');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-checklist/xp-report-checklist.ts